import { FpsStrategy } from './IFpsStrategy'
import { Ticker } from 'pixi.js'

export const pixiStrategy: FpsStrategy = async () => {
  return Ticker.shared.FPS
}
